import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomToneOfVoice,
  BackendQueryCustomToneOfVoiceListArgs,
} from 'src/types/backend';

import { FRAGMENT_CUSTOM_TONE_OF_VOICE } from './schema';

const QUERY = gql`
  query CustomToneOfVoiceList($brandVoiceId: ID!) {
    customToneOfVoiceList(brandVoiceId: $brandVoiceId) {
      ...CustomToneOfVoice
    }
  }
  ${FRAGMENT_CUSTOM_TONE_OF_VOICE}
`;

type Variables = BackendQueryCustomToneOfVoiceListArgs;
type Result = BackendCustomToneOfVoice[];

export const queryCustomToneOfVoiceList = async (variables: Variables) => {
  const result = await executeGqlQuery({ query: QUERY, variables });
  return getSingleProp<Result>(result.data);
};
